<template>
  <div>
    <div class="table--header">
      <div></div>
      <div>
        <a-form layout="inline">
          <a-form-item>
            <ListFilter :filters="filters" @filterChanged="filterChanged"></ListFilter>
          </a-form-item>
          <a-form-item>
            <a-input v-model="searchKey" placeholder="Search" @keyup.enter="keyChanged"></a-input>
          </a-form-item>
          <a-form-item>
            <a-button @click.prevent="keyChanged" style="margin-left: 8px;">Search</a-button>
          </a-form-item>
        </a-form>
      </div>
    </div>

    <a-table
      :columns="columns"
      :loading="loading"
      :style="{margin:'auto',background:'#fff'}"
      :dataSource="sites.data"
      :bordered="false"
      :rowKey="record => record.id"
      :pagination="false"
      @change="handleTableChange"
    >
      <span slot="name" slot-scope="name,rowData">
        <router-link :to="{name:'sites.overview',params:{siteId:rowData.id}}">

          <span>{{ name }}</span>

          <a-tag :color="'geekblue'" v-if="rowData.is_vip_site">VIP</a-tag>
        </router-link>
        &nbsp;
        <a-tooltip placement="top">
          <template slot="title">
            <small>{{ rowData.site_url }}</small>
          </template>
          <a :href="rowData.site_url" target="_blank">
            <a-icon type="link" :style="{ fontSize: '20px', color: '#08c' }"/>
          </a>
        </a-tooltip>

        <a-tooltip v-if="rowData.deactivated_at" :autoAdjustOverflow="false">
          <template slot="title"><small>Plugin disconnected at: {{ rowData.deactivated_at }}</small></template>
          <a-icon type="disconnect" :style="{ fontSize: '20px', color: '#e9452c' }"/>
        </a-tooltip>
      </span>

      <router-link
          :to="{name:'sites.campaigns',params:{siteId:rowData.id}}"
          slot="campaigns_count"
          slot-scope="campaigns_count,rowData"
      >
        {{ campaigns_count }}
      </router-link>


      <a-tag slot="status"
             slot-scope="name, rowData"
            :color="name === 'Active' ? 'green' : 'volcano'"
      >
        {{ name }}
      </a-tag>

      <span slot="amount_paid" slot-scope="amount_paid">
          {{ '$' + numberWithCommas(amount_paid) }}
      </span>

      <span slot="has_custom_plan" slot-scope="name, rowData">
        <a-switch checked-children="Yes"
                  un-checked-children="No"
                  :default-checked="rowData.has_custom_plan"
                  @change="customPlanToggle(rowData.id)"
        />
      </span>
      <span slot="is_vip" slot-scope="name, rowData">
         <a-switch checked-children="Yes"
                   un-checked-children="No"
                   :default-checked="rowData.is_vip_site"
                   @change="vipSiteToggle(rowData.id)"
         />
      </span>
    </a-table>

    <div class="pagination" style="font-weight: normal; float: right; margin-top: 20px; margin-bottom: 20px;" v-if="sites.meta">
      <span>total {{ sites.meta.total }} items</span>
      <span style="margin-left: 15px; margin-right: 15px; color: #cecece;">|</span>
      <span>page {{ sites.meta.current_page }} of {{ sites.meta.last_page }}</span>
      <span style="margin-left: 15px; margin-right: 15px; color: #cecece;" v-if="sites.meta.last_page > 1">|</span>
      <a :disabled="sites.meta.current_page == 1"
          style="margin-right: 10px;"
          class="pagination--btn"
          @click.prevent="paginate(sites.meta.current_page - 1)"
          v-if="sites.meta.last_page > 1"
      >&lt; Previous</a>
      <a
          :disabled="sites.meta.current_page == sites.meta.last_page"
          class="pagination--btn"
          @click.prevent="paginate(sites.meta.current_page + 1)"
          v-if="sites.meta.last_page > 1"
      >Next &gt;</a>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import ListFilter from "@/components/ListFilter.vue";
import Api from "@/services/Api";

export default {
  components: {
    ListFilter
  },

  data() {
    return {
      columns: [
        {
          title: "Site",
          dataIndex: "name",
          sorter: () => {},
          key: "2",
          scopedSlots: { customRender: "name" }
        },
        {
          title: "Campaigns",
          dataIndex: "campaigns_count",
          sorter: () => {},
          key: "campaigns_count",
          scopedSlots: { customRender: 'campaigns_count' },
        },
        {
          title: "Status",
          dataIndex: "locked",
          key: "locked",
          scopedSlots: { customRender: "status" }
        },
        {
          title: "Subscribers",
          dataIndex: "subscribers_count",
          sorter: () => {},
          key: "subscribers_count"
        },
        {
          title: "Total Paid",
          dataIndex: "amount_paid",
          sorter: () => {},
          key: "amount_paid",
          scopedSlots: { customRender: "amount_paid" }
        },
        {
          title: 'Has Custom Plan',
          key: 'has_custom_plan',
          scopedSlots: { customRender: 'has_custom_plan' },
        },
        {
          title: 'Is VIP',
          key: 'is_vip',
          scopedSlots: { customRender: 'is_vip' },
        },

      ],
      filters: [
        {
          id: 'membership_type',
          category: 'Type',
          type: 'checkbox',
          value: [],
          inputs: [
            {value: 'vip', label: 'VIP'}
          ]
        },
        {
          id: 'plan',
          category: 'Plan',
          type: 'checkbox',
          value: [],
          inputs: [
            {value: 'custom', label: 'Custom'}
          ]
        }
      ],
      searchKey: '',
      searchQuery: {
        page: 1,
        orderBy: 'created_at',
        order: 'desc',
        s: '',
        membershipType: '',
        plan: '',
      },
      form: {
        has_custom_plan: false
      },
      loading: false
    };
  },
  computed: {
    ...mapGetters({
      sites: "sites/sites"
    })
  },
  methods: {
    handleTableChange(pagination, filters, sorter) {
        if (sorter.field && sorter.order) {
          this.searchQuery.orderBy = sorter.field;
          this.searchQuery.order = sorter.order;
        }

        this.urlUpdate();
        this.search();
    },

    paginate(page) {
      this.searchQuery.page = page;

      this.urlUpdate();
      this.search();
    },

    search() {
      this.loading = true;
      if (! this.searchQuery) return;
      this.$store.commit("sites/SEARCH_SITE", { query: this.searchQuery, context: this});
    },

    keyChanged () {
      this.resetQuery();
      this.searchQuery.s = this.searchKey;
      this.search();
    },

    filterChanged(data) {
      this.loading = true;
      switch (data.category) {
        case 'membership_type' :
          this.searchQuery.membershipType = data.value;
          break;
        case 'plan' :
          this.searchQuery.plan = data.value;
          break;
        default:
          this.resetQuery();
      }

      this.urlUpdate();

      this.search();
    },

    urlUpdate() {
      let route = {
        name: this.$route.name,
        query: {}
      };

      if (this.searchQuery.membershipType) {
        route.query.membershipType = this.searchQuery.membershipType;
      }
      if (this.searchQuery.plan) {
        route.query.plan = this.searchQuery.plan;
      }
      if (this.searchQuery.page) {
        route.query.page = this.searchQuery.page;
      }
      if (this.searchQuery.orderBy) {
        route.query.orderBy = this.searchQuery.orderBy;
      }
      if (this.searchQuery.order) {
        route.query.order = this.searchQuery.order;
      }

      this.$router.push(route);
    },

    resetQuery() {
      this.searchQuery = {
        page: 1,
        orderBy: 'created_at',
        order: 'desc',
        s: '',
        membershipType: '',
        plan: ''
      };

      this.urlUpdate();
    },

    handleFilterSelection() {
      let vm = this;
      const queryParams = vm.$router.currentRoute.query;

      if (queryParams.page) {
          vm.searchQuery.page = queryParams.page;
      }
      if (queryParams.s) {
          vm.searchQuery.s = queryParams.s;
      }
      if (queryParams.membership_type) {
        const membershipType = queryParams.membership_type;
        if (typeof membershipType === 'string') {
          vm.searchQuery.membershipType = [membershipType];
        } else {
          vm.searchQuery.membershipType = membershipType;
        }
      }
      if (queryParams.plan) {
        const plan = queryParams.plan;
        if (typeof membershipType === 'string') {
          vm.searchQuery.plan = [plan];
        } else {
          vm.searchQuery.plan = plan;
        }
      }
      if (queryParams.orderBy) {
        const orderBy = queryParams.orderBy;
        if (typeof orderBy === 'string') {
          vm.searchQuery.orderBy = orderBy;
        }
      }
      if (queryParams.order) {
        const order = queryParams.order;
        if (typeof order === 'string') {
          vm.searchQuery.order = order;
        }
      }

      this.search();
    },

    customPlanToggle(siteId) {
      this.loading = true;
      Api.get(`/sites/${siteId}/custom-plan`)
          .then(resp => {
            this.loading = false;
            this.$notification['success']({
              message: 'Success',
              description: resp.data.data
            });
            this.search();
          }).catch(err => {
            this.loading = false;
            this.$notification['error']({
              message: 'Error',
              description: 'Something went wrong!'
            });
          });
    },

    vipSiteToggle(siteId) {
      this.loading = true;
      Api.get(`/sites/${siteId}/vip-toggle`)
          .then(resp => {
            this.loading = false;
            this.$notification['success']({
              message: 'Success',
              description: resp.data.data
            });
            this.search();
          }).catch(err => {
            this.loading = false;
            this.$notification['error']({
              message: 'Error',
              description: 'Something went wrong!'
            });
          });
    }
  },
  watch: {
    searchTable(newVal, oldVal) {
      if (oldVal !== '' && newVal === '') {
        this.$store.commit("sites/GET_SITES", { payload: { page: null }, context: this});
      }
    }
  },
  created() {
    this.handleFilterSelection();
  }
};
</script>

<style scoped lang="scss">
  .pagination--btn {
    background-color: #e5e5e5;
    border: 1px solid #ccc;
    border-radius: 5px;
    padding: 5px 9px;
    line-height: 1.8;
  }
  .search {
    padding: 4px 5px 5px;
    margin: 0;
    line-height: 1.3;
    border: 1px solid #e1e1e1;
    border-radius: 5px;
  }
  .search--btn {
    text-decoration: none;
    font-size: 13px;
    line-height: 26px;
    height: 28px;
    margin: 0;
    padding: 0 10px 1px;
    cursor: pointer;
    border-width: 1px;
    border-style: solid;
    -webkit-appearance: none;
    border-radius: 3px;
    white-space: nowrap;
    box-sizing: border-box;
  }
  .table--header {
    display: flex;
    justify-content: space-between;
    margin-bottom: 10px;
  }
</style>
